/**
 * Get file name from url.
 * @param url Url.
 */
export function getFileNameFromUrl(url: string): string {
  const index = url.lastIndexOf('/');
  return url.slice(index + 1);
}
